<div class="container g-0 h-100">

    <div class="row g-0 h-100 align-items-start overflow-auto">
        <div class="col">

            <h4 mat-dialog-title class="pre-line p-2 text-center">{{message}}</h4>
            @if (data.withHashCheck) {
                <mat-form-field class="col">
                    <mat-label>Confirmation</mat-label>
                    <input matInput [(ngModel)]="UserHash" placeholder="Confirmation">
                </mat-form-field>
            }
            @if (WithCancelButton) {
                <button appPreventDoubleClick class="col-6 squared-flat-button" color="primary" mat-stroked-button (throttledClick)="onCancel()">
                    Non
                </button>
            }
            @if (WithCancelButton) {
                <button appPreventDoubleClick class="col-6 squared-flat-button" color="warn" mat-stroked-button (throttledClick)="onConfirm()" [disabled]="UserHash !== Hash">
                    Oui
                </button>
            }
            @if (!WithCancelButton) {
                <button appPreventDoubleClick class="col squared-flat-button" color="primary" mat-stroked-button (throttledClick)="onConfirm()">
                    OK
                </button>
            }
        </div>
    </div>
</div>